<div class="cmdk-newsprev">
  @if (item().imageUrl; as image) {
    <div
      class="cmdk-newsprev__hero"
      role="presentation"
      [style.background-image]="'url(' + image + ')'"></div>
  }

  <div class="cmdk-newsprev__head">
    <h3 class="cmdk-newsprev__title">{{ item().title }}</h3>
    <div class="cmdk-newsprev__meta">
      <paper-tag intent="sky" size="sm">{{ typeLabel() }}</paper-tag>
      @if (item().section; as section) {
        <span class="cmdk-newsprev__section">{{ section }}</span>
      }
      @if (readTime(); as time) {
        <span class="cmdk-newsprev__section">{{ time }}</span>
      }
    </div>
  </div>

  @if (item().summary; as summary) {
    <section class="cmdk-newsprev__section-block">
      <h4 class="cmdk-newsprev__section-title">{{ summaryLabel() }}</h4>
      <p class="cmdk-newsprev__summary">{{ summary }}</p>
    </section>
  }

  <div class="cmdk-newsprev__actions">
    <paper-button
      intent="primary"
      size="sm"
      data-testid="cmdk-preview-run"
      (click)="activated.emit()">
      {{ openLabel() }}
    </paper-button>
    <paper-kbd keys="↵" label="Enter" size="sm" />
  </div>
</div>
